// extracted by mini-css-extract-plugin
module.exports = {"c1":"privacy_c1_2w417","body":"privacy_body_1AffH"};